export default "__VITE_ASSET__aLaHz5Ys__"